import { Component, Input, ViewChild } from '@angular/core';
import {
  TextInputComponent,
  TextModes,
} from '../../ui/controls/text-input/text-input.component';
import { MatDialog } from '@angular/material/dialog';
import { OwnerDialogComponent } from '../../../pages/lead-page/owner-dialog/owner-dialog.component';
import { AddNotesDialogComponent } from '../../../pages/lead-page/add-notes-dialog/add-notes-dialog.component';
import { Router } from '@angular/router';
import { CacheService } from '../../../core/storage/cacheService';
import {
  DdlInputComponent,
  DDLModes,
} from '../../ui/controls/ddl-input/ddl-input.component';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-merchant-application',
  templateUrl: './merchant-application.component.html',
  standalone: false,
})
export class MerchantApplicationComponent {
  @Input() type: string | undefined;

  @ViewChild('ddlState') ddlState: DdlInputComponent | undefined = undefined;
  @ViewChild('txtPostalCode') txtPostalCode: TextInputComponent | undefined =
    undefined;

  inputTextModes = TextModes;
  ddlModes = DDLModes;

  addressOptions = CacheService.addressTypesList;
  cardAcceptanceOptions = CacheService.cardAcceptanceTypesList;
  bankAccountTypes = CacheService.bankAccountTypesList;
  pricingStructureOptions: ListItem[] = [
    new ListItem({ id: 'flatrate', name: 'Flat Rate' }),
    new ListItem({ id: 'tiered', name: 'Tiered' }),
    new ListItem({ id: 'interchangeplus', name: 'Interchange+' }),
  ];

  processorOptions: ListItem[] = [];

  fundingOptions: ListItem[] = [
    new ListItem({
      id: 'Expedited',
      name: 'Expedited - 1-2 Business Days ($5/month)',
    }),
    new ListItem({ id: 'Standard', name: 'Standard 2-3 Business Days (free)' }),
  ];
  secondAccountUsageOptions: ListItem[] = [
    new ListItem({ id: 'Discount', name: 'Discount' }),
    new ListItem({ id: 'Fees', name: 'Fees' }),
    new ListItem({ id: 'Credits', name: 'Credits' }),
    new ListItem({ id: 'Chargebacks', name: 'Chargebacks' }),
  ];

  app = {
    country: '',
  };

  constructor(
    public addNotesDialog: MatDialog,
    public router: Router,
  ) {}

  ngOnInit() {
    if (this.type == 'ACH') {
      this.processorOptions = CacheService.achProcessorList;
    } else {
      this.processorOptions = CacheService.ccProcessorList;
    }
  }

  btnAddOwner_click() {
    let ref = this.addNotesDialog.open(OwnerDialogComponent, {
      width: '500px',
      disableClose: false,
      data: {
        leadId: '',
      },
    });

    this.router.events.subscribe(() => {
      ref.close();
    });

    ref.afterClosed().subscribe((refresh) => {
      if (refresh) {
        // reload owners
      }
    });
  }

  btnAddNotes_click() {
    let ref = this.addNotesDialog.open(AddNotesDialogComponent, {
      width: '500px',
      disableClose: false,
      data: {
        leadId: '',
      },
    });

    this.router.events.subscribe(() => {
      ref.close();
    });

    ref.afterClosed().subscribe((refresh) => {
      if (refresh) {
        // reload history
      }
    });
  }

  ddlCountry_change() {
    if (this.ddlState) {
      this.ddlState.lookupOptions(this.app.country);
    }

    if (this.txtPostalCode) {
      if (this.app.country == 'CA') {
        this.txtPostalCode.type = this.inputTextModes.PostalCodeCAN;
      } else {
        this.txtPostalCode.type = this.inputTextModes.PostalCodeUS;
      }
    }
  }
}
